'use client';

import React, { useState } from 'react';
import Image, { ImageProps } from 'next/image';

interface MultiFallbackImageProps extends Omit<ImageProps, 'src' | 'onError'> {
  sources: string[];
  alt: string;
}

export const MultiFallbackImage: React.FC<MultiFallbackImageProps> = ({ sources: fallbacks, alt, ...props }) => {
  const [sourceIndex, setSourceIndex] = useState(0);
  const currentSrc = fallbacks[sourceIndex];

  const handleError = () => {
    if (sourceIndex < fallbacks.length) {
      setSourceIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <Image
      src={currentSrc}
      onError={handleError}
      alt={alt}
      {...props}
    />
  );
};

export default MultiFallbackImage;